import Button from "core/buttons/button/Button";
import { Typography } from "core/typography/Typography";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import "./ProspectionsTools.scss";
import InputSearchTag from "core/inputs/input-search/InputSearchTag";
import { formatClientOptions } from "components/form/CommonInputs";
import { FORM_INFO } from "constants/forms";
import { FILTERS_FOR_NAMES, TAG_TYPES } from "constants/constants";
import InfoContext from "pages/InfoContext";
function ProspectionsToolsForm() {
  const {
    getNamesByFilters,
    namesByFilters,
    prospectionFilter,
    setProspectionFilter,
    handleGetProspectionsSubmit,
  } = useContext(InfoContext);

  return (
    <div className="prospections-tools-wrapper">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="prospections_tools"
            defaultMessage="Rechercher des prospections"
          />
        }
      />
      <div className="tool-txt">
        <FormattedMessage
          id="desc_prospections_tools"
          defaultMessage="Au minimum 3 lettres sont requises pour la recherche de prospections."
        />
      </div>
      <div className="section-1">
        <div className="cell-padding">
          <InputSearchTag
            errors={{}}
            getOptions={getNamesByFilters}
            filters={{ types: [FILTERS_FOR_NAMES.CLIENT, FILTERS_FOR_NAMES.PROSPECTION] }}
            label={{
              id: "filter_prospection_tools_title",
              defaultMessage: "Nom du client ou prospection",
            }}
            placeholder={{
              id: "filter_prospection_tools_placeholder",
              defaultMessage: "Sephora International",
            }}
            limitChoice={100}
            minLength={2}
            onDelete={(selected) =>
              setProspectionFilter((old) =>
                old.filter((item) => item.value !== selected)
              )
            }
            options={formatClientOptions(
              namesByFilters?.filter((n) =>
                [
                  FILTERS_FOR_NAMES.CLIENT,
                  FILTERS_FOR_NAMES.PROSPECTION,
                ].includes(n?.type)
              )
            )}
            popup={FORM_INFO.clientFilter.popup}
            selectedOptions={prospectionFilter}
            setValue={setProspectionFilter}
            type={TAG_TYPES.CLIENTS}
            id="mission-title-filter"
            required={true}
          />
        </div>
      </div>
      <div className="div-buttons">
        <Button
          color="btn-medium gray-700"
          onClick={() => handleGetProspectionsSubmit()}
          id="button-search"
        >
          <FormattedMessage
            id="search_clients_button_tools"
            defaultMessage="Rechercher le client"
          />
        </Button>
      </div>
    </div>
  );
}

export default ProspectionsToolsForm;
